var map = {
	"./Queue_Image.png": 71521,
	"./Result_Image.png": 73042,
	"./Trends_Image.png": 69419,
	"./android.png": 79875,
	"./ch-code-ai.jpeg": 79582,
	"./ch-ecomm.png": 31479,
	"./ch-exploratoryTest-ai.jpg": 77496,
	"./ch-logo-light.png": 23882,
	"./ch-qa-ai.jpeg": 6781,
	"./chrome.png": 53809,
	"./ecommerce.png": 97163,
	"./edge.png": 16829,
	"./firefox.png": 75570,
	"./ie.png": 59741,
	"./ios.png": 94853,
	"./katespade.png": 65873,
	"./linex.png": 3163,
	"./linux.png": 32561,
	"./loader.gif": 57543,
	"./mac.png": 16352,
	"./no-video.jpg": 26154,
	"./pattern.png": 32407,
	"./safari.png": 48189,
	"./user.svg": 55362,
	"./windows.png": 89024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96303;